import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getShortLink } from '../../utils/api';

function ShortLinkRedirect() {
  const { code } = useParams();

  useEffect(() => {
    // پنهان کردن کامل صفحه و حذف عنوان تا هیچ UI نمایش داده نشود
    const prevTitle = document.title;
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlVis = html.style.visibility;
    const prevBodyVis = body.style.visibility;
    document.title = '';
    html.style.visibility = 'hidden';
    body.style.visibility = 'hidden';

    const run = async () => {
      try {
        if (!code) {
          window.location.replace('/');
          return;
        }
        const res = await getShortLink(code);
        const url = (res?.data?.data || '').trim();
        if (url) {
          window.location.replace(url);
        } else {
          window.location.replace('/');
        }
      } catch (e) {
        // در صورت خطا سریع به صفحه اصلی برگرد
        window.location.replace('/');
      }
    };
    run();

    // هیچ UI رندر نمی‌شود؛ در صورت ماندن در صفحه، وضعیت قبلی را برنمی‌گردانیم
    // چون قصد داریم هیچ‌چیز نمایش داده نشود تا ریدایرکت انجام شود.
  }, [code]);

  // هیچ خروجی UI نده تا چیزی دیده نشود
  return null;
}

export default ShortLinkRedirect;
